import { Map } from 'immutable';
import { GRADE_LIST } from 'shared/util/registrationUtils';

import { AIA_UNIT } from 'shared/constants';

export function isAuthenticated(user, roles) {
	user = Map.isMap(user) ? user.toJS() : user;
	const res = user && roles ? roles.indexOf(user.role) !== -1 : false;
	return res;
}

export function isEmailVerified(user) {
	user = Map.isMap(user) ? user.toJS() : user;
	const res = user.isEmailVerified;
	return res;
}

export function isBasicInfoFilled(user) {
	user = Map.isMap(user) ? user.toJS() : user;
	const res = user.displayName;
	return res;
}

export const getStudentGrade = (gradeValue) => {
	const gradeObj = GRADE_LIST.find((el) => el.id === parseInt(gradeValue) || el.name === gradeValue);

	if (gradeObj) return gradeObj.name;
	else return undefined;
};

export const getUserOrigin = async () => {
	return 'toC';
};

export const getUnitLabel = (unit) => {
	if (unit === AIA_UNIT) return 'AIA';

	return unit;
};

export const getDisplayUnitsString = (unitsString) => {
	return unitsString;
};
